"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _Button = require("../Button.style");

var sizeStyles = function sizeStyles(props) {
  var buttonLayoutCSS =
  /*#__PURE__*/
  (0, _reactEmotion.css)("font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.86px;text-align:center;");

  if (props.size === 'medium') {
    return (
      /*#__PURE__*/
      (0, _reactEmotion.css)(buttonLayoutCSS, ";min-width:90px;height:28px;font-size:12px;")
    );
  }

  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(buttonLayoutCSS, ";min-width:120px;height:36px;font-size:14px;")
  );
};

var statusColors = {
  normal: 'sapphire',
  danger: 'ruby'
};

var buttonHoverActive = function buttonHoverActive(bgcolor, radius) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("&::after{content:'';display:inline-block;background-color:", bgcolor, ";height:100%;width:100%;border-radius:", radius, "px;position:absolute;transition:all 0.25s ease-in-out;}")
  );
};

var typeStyles = function typeStyles(_ref) {
  var color = _ref.theme.color,
      type = _ref.type,
      disabled = _ref.disabled,
      status = _ref.status,
      borderType = _ref.borderType;
  var statusColor = statusColors[status];
  var darkColor = color.dark;
  var whiteColor = darkColor.white;

  if (type === 'filled') {
    return (
      /*#__PURE__*/
      (0, _reactEmotion.css)("background-color:", darkColor[statusColor], ";position:relative;color:", whiteColor, ";fill:", whiteColor, ";border-radius:3px;transition:all 0.3s;& .Loader > circle{stroke:", whiteColor, ";}&:hover{", !disabled && buttonHoverActive(darkColor.white0_1, 3), ";}&:active{", !disabled && buttonHoverActive(darkColor.black0_1, 3), ";}", disabled &&
      /*#__PURE__*/
      (0, _reactEmotion.css)("opacity:", darkColor.disabledOpacity, ";"), ";")
    );
  }

  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("background-color:transparent;color:", whiteColor, ";fill:", whiteColor, ";border-color:", darkColor[statusColor], ";border-radius:2px;border:", borderType, " 1px ", darkColor[statusColor], ";transition:all 0.3s;& .Loader > circle{stroke:", whiteColor, ";}", disabled &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("opacity:", darkColor.disabledOpacity, ";"), ";")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("button", {
  target: "css-1ix8xpu0"
})(_Button.buttonStyles, "\n    ", sizeStyles, "\n    ", typeStyles, "\n    border-radius:4px;"));

exports.default = _default;